export default __webpack_public_path__ + "static/media/YouTubeExportOptions2.98fab1d1.jpg";